import classes from "./styles.module.css";
import { Button, CircularProgress, TextField, Dialog, DialogTitle, DialogContent, DialogActions, FormControl, InputLabel, Select, MenuItem, FormControlLabel, Switch, Typography, Box, Divider } from "@mui/material";
import {
  useReactTable,
  getCoreRowModel,
  getSortedRowModel,
  getFilteredRowModel,
  flexRender,
} from "@tanstack/react-table";
import axios from "axios";
import { path } from "../../../routes";
import { useEffect, useMemo, useState } from "react";
import Row_org_device from "./Row_org_device";
import AddDisplaymodal from "../Modal/AddDisplaymodal";
import EditDisplay_modal from "../Modal/EditDisplay_modal";
import YesNo_modal from "../Modal/YesNo_modal";

const GRID_DISPLAYS_ALL = "minmax(0, 1fr) minmax(0, 1fr) minmax(0, 80px) minmax(200px, auto)";
const GRID_DISPLAYS_ORG = "minmax(0, 1fr) minmax(0, 80px) minmax(200px, auto)";

const SortableHeader = ({ column, children }) => (
  <span
    role="button"
    tabIndex={0}
    onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
    onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && column.toggleSorting(column.getIsSorted() === "asc")}
    style={{ cursor: "pointer", userSelect: "none", display: "inline-flex", alignItems: "center", gap: 4 }}
  >
    {children}
    {column.getIsSorted() === "asc" && " ↑"}
    {column.getIsSorted() === "desc" && " ↓"}
  </span>
);

const Displays = (props) => {
  const [displayList, setdisplayList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filterName, setFilterName] = useState("");
  const [sorting, setSorting] = useState([{ id: "description", desc: false }]);
  const [addNew, setAddNew] = useState(false);
  const [editDisplay, setEditDisplay] = useState(null);
  const [kioskSettingsModal, setKioskSettingsModal] = useState(false);
  const [selectedKioskId, setSelectedKioskId] = useState(null);
  const [kioskDeviceName, setKioskDeviceName] = useState('');
  const [kioskSlideIntervalSec, setKioskSlideIntervalSec] = useState(15);
  const [kioskObjectFit, setKioskObjectFit] = useState('contain');
  const [kioskShowLogo, setKioskShowLogo] = useState(true);
  const [kioskShowClock, setKioskShowClock] = useState(true);
  const [kioskShowDate, setKioskShowDate] = useState(true);
  const [kioskShowTemp, setKioskShowTemp] = useState(true);
  const [kioskMeetingTextColor, setKioskMeetingTextColor] = useState('#ffffff');
  const [kioskMeetingBgColor, setKioskMeetingBgColor] = useState('#003366');
  const [kioskDisplayArrows, setKioskDisplayArrows] = useState({});
  const [deleteConfirm, setDeleteConfirm] = useState(null);

  const showAll = !props.org;

  const closeModal = () => {
    setAddNew(false);
    getDisplays();
  };

  const closeEditModal = () => {
    setEditDisplay(null);
    getDisplays();
  };

  const handleEditDisplay = (display) => {
    // Podle typu zařízení otevřít správný modal
    if (display.device_group === 2) {
      // Kiosk (device_group=2) -> otevřít Kiosk settings
      setSelectedKioskId(String(display.id));
      setKioskDeviceName(display.description || '');
      setKioskSettingsModal(true);
      // Načíst aktuální settings pro tento kiosk
      loadKioskSettings(display.id);
    } else {
      // Display (device_group=1) -> otevřít Edit Display modal
      setEditDisplay(display);
    }
  };

  const loadKioskSettings = async (deviceId) => {
    try {
      const orgId = props.org || displayList.find(d => d.id === deviceId)?.cOrganization_id;
      const url = orgId ? `${path}/getDeviceSettings/${deviceId}?orgID=${encodeURIComponent(orgId)}` : `${path}/getDeviceSettings/${deviceId}`;
      const resp = await axios.get(url);
      const s = resp.data?.settings || {};
      if (typeof s.slideIntervalSec === 'number') setKioskSlideIntervalSec(Math.max(3, Math.min(300, Math.floor(s.slideIntervalSec))));
      if (s.objectFit === 'contain' || s.objectFit === 'cover') setKioskObjectFit(s.objectFit);
      if (typeof s.showLogo === 'boolean') setKioskShowLogo(s.showLogo);
      if (typeof s.showClock === 'boolean') setKioskShowClock(s.showClock);
      if (typeof s.showDate === 'boolean') setKioskShowDate(s.showDate);
      if (typeof s.showTemp === 'boolean') setKioskShowTemp(s.showTemp);
      if (typeof s.meetingTextColor === 'string' && s.meetingTextColor.trim() !== '') {
        setKioskMeetingTextColor(s.meetingTextColor);
      } else {
        setKioskMeetingTextColor('#ffffff');
      }
      if (typeof s.meetingBgColor === 'string' && s.meetingBgColor.trim() !== '') {
        setKioskMeetingBgColor(s.meetingBgColor);
      } else {
        setKioskMeetingBgColor('#003366');
      }
      if (s.displayArrows && typeof s.displayArrows === 'object') {
        setKioskDisplayArrows(s.displayArrows);
      } else {
        setKioskDisplayArrows({});
      }
    } catch (e) {
      console.error('Failed to load kiosk settings:', e);
    }
  };

  const saveKioskSettings = async () => {
    if (!selectedKioskId) {
      alert('Select a kiosk device first.');
      return;
    }
    const payload = {
      slideIntervalSec: Math.max(3, Math.min(300, Number(kioskSlideIntervalSec || 15))),
      objectFit: kioskObjectFit === 'cover' ? 'cover' : 'contain',
      showLogo: Boolean(kioskShowLogo),
      showClock: Boolean(kioskShowClock),
      showDate: Boolean(kioskShowDate),
      showTemp: Boolean(kioskShowTemp),
      meetingTextColor: typeof kioskMeetingTextColor === 'string' && kioskMeetingTextColor.trim() !== ''
        ? kioskMeetingTextColor
        : '#ffffff',
      meetingBgColor: typeof kioskMeetingBgColor === 'string' && kioskMeetingBgColor.trim() !== ''
        ? kioskMeetingBgColor
        : '#003366',
      demoRatio: '9:16',
      displayArrows: kioskDisplayArrows || {}
    };
    try {
      const orgId = props.org || displayList.find(d => d.id === Number(selectedKioskId))?.cOrganization_id;
      // Merge with existing device settings so unrelated keys (e.g. slideshowGroupIds) are preserved.
      let mergedPayload = payload;
      try {
        const getUrl = orgId
          ? `${path}/getDeviceSettings/${selectedKioskId}?orgID=${encodeURIComponent(orgId)}`
          : `${path}/getDeviceSettings/${selectedKioskId}`;
        const currentResp = await axios.get(getUrl);
        const currentSettings = (currentResp.data?.settings && typeof currentResp.data.settings === 'object')
          ? currentResp.data.settings
          : {};
        mergedPayload = { ...currentSettings, ...payload };
      } catch (_) {}
      const selectedDevice = displayList.find(d => String(d.id) === String(selectedKioskId));
      if (selectedDevice) {
        await axios.put(`${path}/updateDisplay/${selectedKioskId}`, {
          name: String(kioskDeviceName || selectedDevice.description || '').trim(),
          type: selectedDevice.device_group,
          organization: orgId,
          roomGroup: selectedDevice.roomGroup ?? selectedDevice.room_group ?? null
        });
      }
      console.log(`[Admin Displays] 💾 Saving kiosk settings for device ${selectedKioskId}:`, mergedPayload);
      const response = await axios.put(`${path}/setDeviceSettings/${selectedKioskId}`, { settings: mergedPayload, orgID: orgId });
      console.log(`[Admin Displays] ✅ Settings saved successfully:`, response.data);
      closeKioskSettingsModal();
      alert(`Kiosk settings saved to device ${selectedKioskId}. The kiosk will update automatically.`);
    } catch (e) {
      console.error('[Admin Displays] ❌ Failed to save kiosk settings:', e);
      console.error('[Admin Displays] Error details:', e.response?.data);
      alert('Could not save to device. Check connection.');
    }
  };

  const closeKioskSettingsModal = () => {
    setKioskSettingsModal(false);
    setSelectedKioskId(null);
    setKioskDeviceName('');
    // Reset načtených hodnot
    setKioskSlideIntervalSec(15);
    setKioskObjectFit('contain');
    setKioskShowLogo(true);
    setKioskShowClock(true);
    setKioskShowDate(true);
    setKioskShowTemp(true);
    setKioskMeetingTextColor('#ffffff');
    setKioskMeetingBgColor('#003366');
    setKioskDisplayArrows({});
    getDisplays();
  };

  const deleteDisplay = async (id) => {
    try {
      await axios.delete(`${path}/deletedisplay/${id}`);
      alert("Zobrazovač smazán úspěšně");
      setDeleteConfirm(null);
      getDisplays();
    } catch (error) {
      console.error("Chyba při mazání:", error);
      alert("Mazání se nezdařilo");
      setDeleteConfirm(null);
    }
  };

  const handleDeleteRequest = (display) => {
    setDeleteConfirm({
      id: display.id,
      name: display.description || `Zobrazovač #${display.id}`,
    });
  };

  const getDisplays = async () => {
    setLoading(true);
    setdisplayList([]);
    try {
      // Zobrazovače: všechna zařízení (displeje + kiosky)
      const url = showAll ? `${path}/getDisplaysAll` : `${path}/getDevicesByOrg/${props.org}`;
      const response = await axios.get(url);
      setdisplayList(response.data || []);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getDisplays();
  }, [props.org]);

  const columns = useMemo(() => {
    const cols = [];
    if (showAll) {
      cols.push({
        id: "organizationName",
        accessorFn: (r) => r.organizationName || r.cOrganization_id || "—",
        header: ({ column }) => <SortableHeader column={column}>Organizace</SortableHeader>,
        enableSorting: true,
      });
    }
    cols.push(
      {
        id: "description",
        accessorFn: (r) => r.description || "",
        header: ({ column }) => <SortableHeader column={column}>Název</SortableHeader>,
        enableSorting: true,
        sortingFn: (rowA, rowB) =>
          (rowA.original.description || "").localeCompare(rowB.original.description || "", "cs"),
      },
      {
        id: "device_group",
        accessorFn: (r) => (r.device_group === 1 ? "Displej" : "Kiosk"),
        header: ({ column }) => <SortableHeader column={column}>Typ</SortableHeader>,
        enableSorting: true,
        sortingFn: (rowA, rowB) =>
          (rowA.original.device_group === 1 ? 0 : 1) - (rowB.original.device_group === 1 ? 0 : 1),
      },
      { id: "actions", header: "Action Buttons", enableSorting: false }
    );
    return cols;
  }, [showAll]);

  const table = useReactTable({
    data: displayList,
    columns,
    state: { sorting, globalFilter: filterName },
    onSortingChange: setSorting,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    globalFilterFn: (row, _columnId, filterValue) => {
      const q = (filterValue || "").trim().toLowerCase();
      if (!q) return true;
      const name = (row.original.description || "").toLowerCase();
      const org = (row.original.organizationName != null ? String(row.original.organizationName) : "").toLowerCase();
      return name.includes(q) || org.includes(q);
    },
  });

  const gridColumns = showAll ? GRID_DISPLAYS_ALL : GRID_DISPLAYS_ORG;
  const headerGroup = table.getHeaderGroups()[0];
  const rows = table.getRowModel().rows;
  const colCount = headerGroup?.headers.length ?? 0;

  return (
    <>
      <div className={classes.main}>
        <div className={classes.buttons}>
          {!showAll && (
            <Button
              onClick={() => setAddNew(true)}
              color="primary"
              variant="contained"
              sx={{ fontSize: { xs: "0.875rem", sm: "1rem" }, padding: { xs: "8px 16px", sm: "10px 20px" } }}
            >
              Přidat zobrazovač
            </Button>
          )}
          <TextField
            size="small"
            placeholder="Filtrovat podle názvu..."
            value={filterName}
            onChange={(e) => setFilterName(e.target.value)}
            sx={{ minWidth: { xs: 160, sm: 220 } }}
            inputProps={{ "aria-label": "Filtrovat podle názvu" }}
          />
        </div>
        <div className={classes.table}>
          <div
            className={classes.tableGridWrapper}
            style={{ gridTemplateColumns: gridColumns }}
          >
            <div style={{ display: "contents" }}>
              {headerGroup?.headers.map((header, i) => (
                <div
                  key={header.id}
                  className={`${classes.cellHeader} ${i === 0 ? classes.cellColFirst : ""} ${i === colCount - 1 ? classes.cellColLast : ""} ${header.column.id === "actions" ? classes.columnAct : classes.column}`}
                >
                  {flexRender(header.column.columnDef.header, header.getContext())}
                </div>
              ))}
            </div>
            {loading && (
              <div className={classes.loader} style={{ gridColumn: "1 / -1" }}>
                <CircularProgress size={40} />
              </div>
            )}
            {!loading && displayList.length === 0 && (
              <div className={classes.empty} style={{ gridColumn: "1 / -1" }}>
                Žádné zobrazovače
              </div>
            )}
            {!loading && displayList.length > 0 && rows.length === 0 && (
              <div className={classes.empty} style={{ gridColumn: "1 / -1" }}>
                Žádný výsledek pro „{filterName.trim()}“
              </div>
            )}
            {!loading &&
              rows.map((row, rowIndex) => (
                <Row_org_device
                  key={row.original.id}
                  data={row.original}
                  showOrg={showAll}
                  gridColumns={gridColumns}
                  renderAsGridRow
                  isLastRow={rowIndex === rows.length - 1}
                  onDeleteRequest={handleDeleteRequest}
                  onEdit={handleEditDisplay}
                />
              ))}
          </div>
        </div>
      </div>
      {addNew && <AddDisplaymodal close={closeModal} org={props.org} />}
      {editDisplay && (
        <EditDisplay_modal
          close={closeEditModal}
          display={editDisplay}
          orgId={editDisplay.cOrganization_id ?? props.org}
          allowKioskSettings={true}
        />
      )}
      {kioskSettingsModal && (
        <Dialog
          open={kioskSettingsModal}
          onClose={closeKioskSettingsModal}
          maxWidth="md"
          fullWidth
          PaperProps={{ sx: { borderRadius: '12px' } }}
        >
          <DialogTitle sx={{ fontWeight: 700 }}>Kiosk settings</DialogTitle>
          <DialogContent sx={{ pt: 2.5, pb: 2.5 }}>
            <Typography variant="body2" sx={{ color: '#666', mb: 2 }}>
              These settings are saved to the selected kiosk device (database). They apply when the kiosk loads with its URL.
            </Typography>

            <Box sx={{
              display: 'grid',
              gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
              gap: 2,
              alignItems: 'center'
            }}>
              <TextField
                fullWidth
                label="Device name"
                value={kioskDeviceName}
                onChange={(e) => setKioskDeviceName(e.target.value)}
                sx={{ gridColumn: { xs: '1', sm: '1 / span 2' } }}
              />
              <TextField
                fullWidth
                type="number"
                label="Slide interval (s)"
                value={kioskSlideIntervalSec}
                inputProps={{ min: 3, max: 300, step: 1 }}
                onChange={(e) => setKioskSlideIntervalSec(Math.max(3, Math.min(300, Number(e.target.value || 15))))}
              />

              <FormControl fullWidth>
                <InputLabel id="fit-label">Object-fit</InputLabel>
                <Select
                  labelId="fit-label"
                  label="Object-fit"
                  value={kioskObjectFit}
                  onChange={(e) => setKioskObjectFit(e.target.value)}
                >
                  <MenuItem value="contain">contain (no distortion)</MenuItem>
                  <MenuItem value="cover">cover</MenuItem>
                </Select>
              </FormControl>
            </Box>

            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, mt: 2, alignItems: 'center' }}>
              <FormControlLabel control={<Switch checked={kioskShowLogo} onChange={(e) => setKioskShowLogo(e.target.checked)} />} label="Logo" />
              <FormControlLabel control={<Switch checked={kioskShowClock} onChange={(e) => setKioskShowClock(e.target.checked)} />} label="Clock" />
              <FormControlLabel control={<Switch checked={kioskShowDate} onChange={(e) => setKioskShowDate(e.target.checked)} />} label="Date" />
              <FormControlLabel control={<Switch checked={kioskShowTemp} onChange={(e) => setKioskShowTemp(e.target.checked)} />} label="Temperature" />
            </Box>

            <Box sx={{ mt: 2, display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' }, gap: 2 }}>
              <TextField
                fullWidth
                type="color"
                label="Meeting text color"
                value={kioskMeetingTextColor}
                onChange={(e) => setKioskMeetingTextColor(e.target.value || '#ffffff')}
                InputLabelProps={{ shrink: true }}
              />
              <TextField
                fullWidth
                type="color"
                label="Meeting background color"
                value={kioskMeetingBgColor}
                onChange={(e) => setKioskMeetingBgColor(e.target.value || '#003366')}
                InputLabelProps={{ shrink: true }}
              />
            </Box>

            {displayList.filter(d => Number(d.device_group) === 1).length > 0 && (
              <Box sx={{ mt: 3 }}>
                <Divider sx={{ mb: 2 }} />
                <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 1 }}>
                  Display arrows (meeting list)
                </Typography>
                <Typography variant="body2" sx={{ color: '#666', mb: 1.5 }}>
                  Enable and set arrow direction for each display. The arrow will appear next to the meeting on the kiosk.
                </Typography>
                {displayList
                  .filter(d => Number(d.device_group) === 1)
                  .map(d => {
                    const did = String(d.id);
                    const hasArrow = did in kioskDisplayArrows;
                    const dir = kioskDisplayArrows[did] || 'right';
                    return (
                      <Box key={did} sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5, flexWrap: 'wrap' }}>
                        <Switch
                          size="small"
                          checked={hasArrow}
                          onChange={(e) => {
                            setKioskDisplayArrows(prev => {
                              const next = { ...prev };
                              if (e.target.checked) next[did] = 'right';
                              else delete next[did];
                              return next;
                            });
                          }}
                        />
                        <Typography variant="body2" sx={{ minWidth: 140 }}>
                          {d.description || `Display #${d.id}`}
                        </Typography>
                        {hasArrow && (
                          <FormControl size="small" sx={{ minWidth: 130 }}>
                            <Select
                              value={dir}
                              onChange={(e) => {
                                setKioskDisplayArrows(prev => ({ ...prev, [did]: e.target.value }));
                              }}
                            >
                              <MenuItem value="right">Right →</MenuItem>
                              <MenuItem value="left">Left ←</MenuItem>
                              <MenuItem value="up">Up ↑</MenuItem>
                              <MenuItem value="down">Down ↓</MenuItem>
                              <MenuItem value="up-right">Up-right ↗</MenuItem>
                              <MenuItem value="up-left">Up-left ↖</MenuItem>
                              <MenuItem value="down-right">Down-right ↘</MenuItem>
                              <MenuItem value="down-left">Down-left ↙</MenuItem>
                            </Select>
                          </FormControl>
                        )}
                      </Box>
                    );
                  })}
              </Box>
            )}
          </DialogContent>
          <DialogActions sx={{ px: 3, pb: 2 }}>
            <Button variant="outlined" onClick={closeKioskSettingsModal}>Cancel</Button>
            <Button variant="contained" disabled={!selectedKioskId} onClick={saveKioskSettings}>Save</Button>
          </DialogActions>
        </Dialog>
      )}
      {deleteConfirm && (
        <YesNo_modal
          text="Opravdu chcete odstranit tento zobrazovač?"
          line={deleteConfirm.name}
          id={deleteConfirm.id}
          close={() => setDeleteConfirm(null)}
          delete={deleteDisplay}
        />
      )}
    </>
  );
};

export default Displays;
